import { atom } from "jotai";
import type { ActivityPeriod, DashboardScopeMode } from "../types";
import { dashboardScopeAtom } from "./scopeAtoms";

/**
 * Range a scope opens on: one person's work reads best over the week, a team's
 * over the month.
 */
export const getDefaultActivityPeriod = (
  mode: DashboardScopeMode,
): ActivityPeriod => (mode === "me" ? "this_week" : "this_month");

/**
 * The range the user picked in the section header, or null while the section is
 * still following the scope default. Cleared on every scope change so switching
 * Me/Team lands on that scope's default — see `useDashboardScope`.
 */
export const activityPeriodOverrideAtom = atom<ActivityPeriod | null>(null);

/**
 * The single period every Activity card is scoped to. The section header owns
 * the only filter, so changing it refetches all five cards at once.
 */
export const activityPeriodAtom = atom(
  (get) =>
    get(activityPeriodOverrideAtom) ??
    getDefaultActivityPeriod(get(dashboardScopeAtom).mode),
  (_get, set, period: ActivityPeriod) => {
    set(activityPeriodOverrideAtom, period);
  },
);
